import React from "react";

export const AccountLedgerDetailContext = React.createContext(null);

export const useAccountLedgerDetailContext = () => {
  const context = React.useContext(AccountLedgerDetailContext);

  if (!context) throw new Error("Payment Account Detail Context not provided!");

  return context;
};
